export default function CustomersController(customersService, notificationHelper) {
  var vm = this;

  vm.isLoading = false;
  vm.showInfoMessage = true;
  vm.customers = [];
  vm.total = 0;
  vm.currentPage = 0;
  vm.maxPaginationSize = 5;

  vm.customerParams = {
    customerId: null,
    email: '',
    phone: '',
    offset: 0,
    limit: 50,
  };

  vm.pageChanged = pageChanged;
  vm.getCustomers = getCustomers;

  function getCustomers() {
    setCustomerListDefaultValues();
    getCustomersByOffset();
  }

  function setCustomerListDefaultValues() {
    vm.total = 0;
    vm.customerParams.offset = 0;
    vm.currentPage = 0;
  }

  function getCustomersByOffset() {
    if (vm.isLoading) {
      return;
    }
    vm.showInfoMessage = false;
    enableLoading();
    customersService
      .getCustomers(vm.customerParams)
      .then(initCustomers)
      .catch(function(res) {
        notificationHelper.showError(res, 'Error retrieving customers');
      })
      .finally(disableLoading);
  }

  function initCustomers(res) {
    if (res && res.data) {
      vm.total = res.data.total;
      vm.customers = res.data.customerSearchDtos;

      if (res.data.message) {
        notificationHelper.showError(res, res.data.message);
      }
    }
  }

  function pageChanged() {
    calculatePagination();
    getCustomersByOffset();
  }

  function calculatePagination() {
    vm.customerParams.offset = vm.currentPage * vm.customerParams.limit - vm.customerParams.limit;
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/customers/customers.controller.js